import './Title.css';

export default function Title() {
  return (
    <div className='title'>
      <h1>Chapter 1 : Planetary Motion</h1>
    </div>
  );
}
